import { ApiClientConfig } from '../../types/ApiClientConfig';

export const OneSearchUrlsPerStage: ApiClientConfig = {
  LOCAL: {
    basePath: 'https://eu.api.oneweb.mercedes-benz.com/commerce/onesearch/v2',
    apiKey: '2e6bf31f-1088-4497-84a5-3a0b8d429cc7',
  },
  TEST: {
    basePath: 'https://test.eu.api.oneweb.mercedes-benz.com/commerce/onesearch/int//v2',
    apiKey: 'c5ee7d0e-c68e-475e-bf57-a4b9658dfa40',
  },
  INT: {
    basePath: 'https://test.eu.api.oneweb.mercedes-benz.com/commerce/onesearch/int/v2',
    apiKey: 'c5ee7d0e-c68e-475e-bf57-a4b9658dfa40',
  },
  PPROD: {
    basePath: 'https://int.eu.api.oneweb.mercedes-benz.com/commerce/onesearch/eu/v2',
    apiKey: '08a088fc-54d8-4cd7-ae39-4c85508de4c0',
  },
  PROD: {
    basePath: 'https://eu.api.oneweb.mercedes-benz.com/commerce/onesearch/graphql',
    apiKey: '2e6bf31f-1088-4497-84a5-3a0b8d429cc7',
  },
};

export const OneSearchOverseasUrlsPerStage: ApiClientConfig = {
  LOCAL: {
    basePath: 'https://ap.api.oneweb.mercedes-benz.com/commerce/onesearch/v2',
    apiKey: '2e6bf31f-1088-4497-84a5-3a0b8d429cc7',
  },
  TEST: {
    basePath: 'https://test.eu.api.oneweb.mercedes-benz.com/commerce/onesearch/int//v2',
    apiKey: 'c5ee7d0e-c68e-475e-bf57-a4b9658dfa40',
  },
  INT: {
    basePath: 'https://int.eu.api.oneweb.mercedes-benz.com/commerce/onesearch/os/v2',
    apiKey: 'c5ee7d0e-c68e-475e-bf57-a4b9658dfa40',
  },
  PPROD: {
    basePath: 'https://ap.api.oneweb.mercedes-benz.com/commerce/onesearch/v2',
    apiKey: '08a088fc-54d8-4cd7-ae39-4c85508de4c0',
  },
  PROD: {
    basePath: 'https://ap.api.oneweb.mercedes-benz.com/commerce/onesearch/v2',
    apiKey: '2e6bf31f-1088-4497-84a5-3a0b8d429cc7',
  },
};
